// extracted by mini-css-extract-plugin
module.exports = {"UserStatContainer":"UserStat_UserStatContainer__3Mjpb","UserStatName":"UserStat_UserStatName__3zMrz","UserStatValue":"UserStat_UserStatValue__Hthyu"};